import React from 'react';
import {siteName} from './util';

export default (props) => (
    <h2>
        {siteName}
    </h2>
);
